import React, { Component } from 'react';

import Logo from '../Components/Logo.js';
import PageMenu from './PageMenu.js';
import styled from 'styled-components';
import Borders from "./Borders";

const StyledHeader = styled.div`
  padding-top: 40px;
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  font-weight: bold;
    
  @media (max-width: 800px) {
    padding-top: 20px;
  } 
`;

class Header extends Component {
  render() {
    return (
      <Borders>
        <StyledHeader>
          <Logo />


        </StyledHeader>
      </Borders>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/Containers/Header.js